import { memo, useMemo } from "react";
import { Table, Button, Typography, Badge } from "antd";
import { ShopOutlined } from "@ant-design/icons";
import styles from "../styles/UberSyncUI.module.css";

const { Text } = Typography;

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    width: 70,
    align: "center",
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: "Sucursal",
    dataIndex: "name",
    width: 150,
    render: (val) => <Text strong className={styles.branchNameText}>{val || "-"}</Text>,
  },
  {
    title: "Dirección",
    dataIndex: "address",
    ellipsis: true,
    render: (val) => <Text type="secondary">{val || "-"}</Text>,
  },
  {
    title: "ID Uber Eats",
    dataIndex: "uber_id",
    width: 200,
    render: (val) => <Text code>{val || "-"}</Text>,
  },
  {
    title: "Estado Uber",
    dataIndex: "uber_active",
    align: "center",
    width: 120,
    render: (isActive) => (
      <Badge
        status={isActive ? "success" : "default"}
        text={isActive ? "Habilitado" : "Deshabilitado"}
      />
    ),
  },
];

const BranchesTable = ({ branches, selectedRowKeys, onSelectRowKeysChange }) => {
  const checkableBranches = branches.filter(b => b.uber_active);
  const allChecked = checkableBranches.length > 0 && checkableBranches.every(b => selectedRowKeys.includes(b.id));

  const handleToggleSelectAll = () => {
    if (allChecked) {
      onSelectRowKeysChange([]);
    } else {
      onSelectRowKeysChange(checkableBranches.map(b => b.id));
    }
  };

  const rowSelection = useMemo(() => ({
    selectedRowKeys,
    onChange: onSelectRowKeysChange,
    getCheckboxProps: (record) => ({
      disabled: !record.uber_active,
      name: record.name,
    }),
  }), [selectedRowKeys, onSelectRowKeysChange]);

  return (
    <div className={styles.leftPanel}>
      <div className={styles.titleArea}>
        <span className={styles.titleText}>
          <ShopOutlined /> Sucursales ({branches.length})
        </span>
        {checkableBranches.length > 0 && (
          <Button size="small" type="link" onClick={handleToggleSelectAll}>
            {allChecked ? "Deseleccionar todas" : "Seleccionar disponibles"}
          </Button>
        )}
      </div>

      <div className={styles.infoText}>
        <Text type="secondary">
          Solo se pueden marcar las sucursales con estado <strong>Habilitado</strong> en Uber.
        </Text>
      </div>

      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={branches}
        rowKey="id"
        pagination={false}
        bordered
        size="small"
        scroll={{ x: 650 }}
      />
    </div>
  );
};

export default memo(BranchesTable);
